<template>
  <div class="description">
    <div class="column">
      <img class="main" src="@/assets/swiper/swiper1.png" />
    </div>
    <div class="column">
      <div class="wrpper" v-if="screenWidth > 768">
        <Swiper
          :imgUrl="urlOne"
          :during="during1"
          :setHeight="setHg1"
          :pageView="page1"
        >
        </Swiper>
        <div class="two-line">
        </div>
      </div>
      <div v-else>
        <img class="main" src="@/assets/web/002.png" />
      </div>
    </div>
    <div class="column">
      <img class="main" src="@/assets/web/004.png" />
    </div>
  </div>
</template>
<script>
import Swiper from "./Swiper";
export default {
  name: "Intro",
  components: { Swiper },
  data() {
    return {
      infoList: [
        {
          num: 2,
          name: "研发中心",
          sub: "(深圳研发中心和宁波研发中心)",
        },
        {
          num: 1,
          name: "制造工厂",
          sub: "(台州温岭)",
        },
        {
          num: 4,
          name: "跨境独立站",
          sub: "(四方跨境独立站一站式服务平台)",
        },
      ],

      during1: 4000,
      during2: 4000,
      setHg1: "800px",
      setHg2: "600px",
      page1: 1,
      page2: 2,
      urlOne: [
        {
          img: require("@/assets/swiperHome/002.png"),
        },
        {
          img: require("@/assets/swiperHome/003.png"),
        },
        {
          img: require("@/assets/swiperHome/004.png"),
        },
        {
          img: require("@/assets/swiperHome/005.png"),
        },
        {
          img: require("@/assets/swiperHome/006.png"),
        },
      ],
      urlTwo: [
        {
          img: require("@/assets/swiperHome/008.png"),
        },
        {
          img: require("@/assets/swiperHome/009.png"),
        },
        {
          img: require("@/assets/swiperHome/008.png"),
        },
        {
          img: require("@/assets/swiperHome/009.png"),
        },
      ],
      screenWidth: localStorage.getItem("screenWidth") || window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth); // 移除监听器
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth =
        localStorage.getItem("screenWidth") || window.innerWidth; // 更新屏幕宽度
    },
  },
};
</script>
<style less scoped>
.description {
  width: 100%;
  .flag {
    width: 90%;
    margin: 10px auto;
    ul {
      display: flex;
      li {
        text-align: center;
        list-style: none;
        width: 30%;
      }
    }
  }
}
.column {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
}
.two-line {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 600px;
  background: url("../../assets/web/intro.png") no-repeat;
  background-size: cover;
  font-size: 24px;
}

.wrpper {
  width: 100%;
  margin: 0px auto;
}
.column .main {
  text-align: center;
  width: 100%;
}
.cloumn2 {
  width: 100%;
}
.cloumn2 img {
  height: 100%;
}

.con .big {
  color: #0598eb;
  font-size: 30px;
  font-weight: bold;
}
.con p {
  height: 10px;
  line-height: 10px;
}
.step1 {
  display: flex;
  justify-content: space-between;
}
.step1 img {
  width: 50%;
}
.step1 .tips {
  width: 40%;
  text-align: center;
}
.step2 {
  width: 100%;
  margin: 0px auto;
}
.step2 img {
  margin-left: 15%;
  width: 70%;
  left: 15%;
}
.step3 {
  width: 100%;
  margin: 0px auto;
}
.step3 img {
  margin-left: 15%;
  width: 70%;
}
.step4 {
  width: 100%;
  margin: 0px auto;
}
.step4 img {
  margin-left: 5%;
  width: 90%;
}
.step5 {
  width: 100%;
  margin: 0px auto;
}
.step5 img {
  margin-left: 5%;
  width: 90%;
}
.step6 {
  width: 100%;
  margin: 0px auto;
}
.step6 img {
  margin-left: 5%;
  width: 90%;
}
.step7 {
  width: 100%;
  margin: 0px auto;
}
.step7 img {
  margin-left: 5%;
  width: 90%;
}
.tips img {
  margin-top: 25%;
  width: 50px;
}
.tips span {
  display: block;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0598eb;
  font-weight: bold;
  font-size: 30px;
}
</style>